import React, { Component } from 'react';
import { Link } from 'react-router';
import styles from './AdminMenu.scss';

export default class AdminLink extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            isInstitutionalAdmin,
        } = this.props;

        return isInstitutionalAdmin ? <SingleInstitution /> : null;
    }
}

const SingleInstitution = () => {
    return (
        <Link to="/admin/users" className={styles.adminMenu__singleInstitution} data-cy="AdminLink">
            <p className={styles.adminMenu__singleInstitutionLabel}>Admin</p>
            <i className={styles.adminMenu__targetIcon}>settings</i>
        </Link>
    );
};